/* eslint-disable import/no-anonymous-default-export */
// import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { get, size } from 'lodash';
import { getInfoCustomerPaymentApi, getListBankApi, getListBankBranchApi, postNewInfoCustomerPaymentApi } from './helpers';
import { GetInfoCustomerPaymentDone, GetListBankBranchDone, GetListBankDone } from './action';
import { CREATE_INFO_CUSTOMER_PAYMENT, GET_INFO_CUSTOMER_PAYMENT, GET_LIST_BANK, GET_LIST_BANK_BRANCH } from './constant';

function* takeGetInfoCustomerPaymentSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getInfoCustomerPaymentApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(GetInfoCustomerPaymentDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListBankSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListBankApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(GetListBankDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takeGetListBankBranchSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(getListBankBranchApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
      yield put(GetListBankBranchDone(data));
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

function* takePostNewInfoCustomerPaymentgSaga(action: ActionType) {
  try {
    action.callback?.onBegin?.()
    const { data } = yield call(postNewInfoCustomerPaymentApi, action.payload);
    if (size(data) >= 0) {
      action.callback?.onSuccess?.(data)
    } else {
      action.callback?.onFail?.("Không có dữ liệu");
    }
  } catch (error) {
    action.callback?.onFail?.(get(error,'response.data',''));
  } finally {
    action.callback?.onFinish?.()
  }
}

export default function* () {
  yield takeLatest(GET_INFO_CUSTOMER_PAYMENT, takeGetInfoCustomerPaymentSaga);
  yield takeLatest(GET_LIST_BANK, takeGetListBankSaga);
  yield takeLatest(GET_LIST_BANK_BRANCH, takeGetListBankBranchSaga);
  yield takeLatest(CREATE_INFO_CUSTOMER_PAYMENT, takePostNewInfoCustomerPaymentgSaga);
}

